import styled, { css } from 'styled-components';
import { device } from '../breakpoints';
import {
    regularBlack,
    playGrey20,
    darkRed,
    regularWhite,
    regularYellow,
    fontWeightBold,
} from '../design-tokens';
import { playFontSize } from '../typography/helpers';
import { PlayBadge } from '../typography/PlayBadge.styles';
import { THEMES } from './PlayBadge';

const getTheme = (theme) => {
    switch (theme) {
        case THEMES.UPCOMING:
            return css`
                background: ${playGrey20};
                color: ${regularWhite};
            `;
        case THEMES.UPCOMING_MEDIUM:
            return css`
                background: ${playGrey20};
                color: ${regularWhite};
                @media ${device.GteSmall} {
                    ${playFontSize(1.5)}
                    padding: 7px;
                }
            `;
        case THEMES.OPEN_ARCHIVE_SMALL:
            return css`
                font-size: 20px;
                background: ${regularBlack};
                color: ${regularWhite};
                ${playFontSize(0.75)}
                padding: 2px;
                top: 2px;
                left: 2px;

                @media ${device.GteSmall} {
                    ${playFontSize(0.75)}
                    padding: 2px;
                }
            `;
        case THEMES.LAST_CHANCE:
            return css`
                background: ${regularYellow};
                color: ${regularBlack};
            `;
        case THEMES.LIVE:
            return css`
                background: ${darkRed};
                color: ${regularWhite};
            `;
        case THEMES.LIVE_MEDIUM:
            return css`
                background: ${darkRed};
                color: ${regularWhite};
                @media ${device.GteSmall} {
                    ${playFontSize(1.5)}
                    padding: 7px;
                }
            `;
        case THEMES.LIVE_LARGE:
            return css`
                background: ${darkRed};
                color: ${regularWhite};
                ${playFontSize(1.3)}
                font-weight: ${fontWeightBold};
                padding: 5px;

                @media ${device.GteLarge} {
                    font-size: 20px;
                }
            `;
        default:
            return css`
                background: ${regularBlack};
                color: ${regularWhite};
            `;
    }
};

export const BadgeWrapper = styled.div`
    ${PlayBadge}
    text-transform: uppercase;
    font-weight: bold;
    padding: 4px 5px;
    z-index: 1;
    display: inline-block;
    line-height: 1;

    @media ${device.GteMedium} {
        padding: 5px 6px;
    }

    ${(props) =>
        props.overlay &&
        css`
            position: absolute;
            top: 5px;
            left: 5px;
        `}

    ${(props) => getTheme(props.theme)}
`;

export const A11yText = styled.span`
    display: none;
`;
